import React, { useState, useEffect, useRef } from 'react'
import '../../../styles/MenuMobile.css'
import { Link as LinkScroll } from 'react-scroll'
import { Link as LinkRouter } from 'react-router-dom'
import menuHamburger from '../../../assets/icones/menu-hamburger-bleu.png'

function MenuMobile() {
  const menuMRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [openSubMenu, setOpenSubMenu] = useState(null)

  // Fermeture si clic à l'extérieur
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        menuOpen &&
        menuMRef.current &&
        !menuMRef.current.contains(e.target)
      ) {
        setMenuOpen(false)
        setOpenSubMenu(null)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [menuOpen])

  const toggleMenu = () => {
    if (menuOpen) setOpenSubMenu(null)
    setMenuOpen(!menuOpen)
  }

  const toggleSubMenu = (name) => {
    setOpenSubMenu((prev) => (prev === name ? null : name))
  }

  const closeAll = () => {
    setMenuOpen(false)
    setOpenSubMenu(null)
  }

  return (
    <div id="MenuM" className="conteneurMenuM">
      {/* Icône hamburger */}
      <button className="iconeHamburger" onClick={toggleMenu} aria-label="Menu">
        <img src={menuHamburger} alt="Menu" className="iconeHamburgerImg" />
      </button>

      {/* Menu */}
      <nav
        ref={menuMRef}
        className={`menuM ${menuOpen ? 'menuMOpen' : ''}`}
        aria-hidden={!menuOpen}
      >
        <LinkScroll
          to="Accueil"
          smooth
          duration={1000}
          className="menuMItem"
          onClick={closeAll}
        >
          Accueil
        </LinkScroll>

        {/* Cours */}
        <div className="menuMItem" onClick={() => toggleSubMenu('cours')}>
          Cours
          <svg
            viewBox="0 0 1030 638"
            width="10"
            className={`arrowIcon ${openSubMenu === 'cours' ? 'arrowIconOpen' : ''}`}
          >
            <path
              d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
              fill="#FFF"
            />
          </svg>
        </div>
        <div
          className={`sousMenuM ${openSubMenu === 'cours' ? 'sousMenuMOpen' : ''}`}
        >
          <LinkScroll
            to="Professeurs"
            smooth
            duration={1000}
            className="sousMenuMItem"
            onClick={closeAll}
          >
            Professeurs
          </LinkScroll>
          <LinkScroll
            to="HorairesTarifs"
            smooth
            duration={1000}
            className="sousMenuMItem"
            onClick={closeAll}
          >
            Horaires
          </LinkScroll>
          <LinkScroll
            to="HorairesTarifs"
            smooth
            duration={1000}
            className="sousMenuMItem"
            onClick={closeAll}
          >
            Tarifs
          </LinkScroll>
        </div>

        {/* Inscription */}
        <div className="menuMItem" onClick={() => toggleSubMenu('inscription')}>
          Inscription
          <svg
            viewBox="0 0 1030 638"
            width="10"
            className={`arrowIcon ${openSubMenu === 'inscription' ? 'arrowIconOpen' : ''}`}
          >
            <path
              d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
              fill="#FFF"
            />
          </svg>
        </div>
        <div
          className={`sousMenuM ${openSubMenu === 'inscription' ? 'sousMenuMOpen' : ''}`}
        >
          <a
            href={`${process.env.PUBLIC_URL}/PDF/Bulletin d'inscriptionWeb2025-2026.pdf`}
            target="_blank"
            rel="noreferrer"
            className="sousMenuMItem"
            onClick={closeAll}
          >
            Bulletin
          </a>
        </div>

        <LinkScroll
          to="Evenements"
          smooth
          duration={1000}
          className="menuMItem"
          onClick={closeAll}
        >
          Événements
        </LinkScroll>

        {/* Médias */}
        <div className="menuMItem" onClick={() => toggleSubMenu('medias')}>
          Médias
          <svg
            viewBox="0 0 1030 638"
            width="10"
            className={`arrowIcon ${openSubMenu === 'medias' ? 'arrowIconOpen' : ''}`}
          >
            <path
              d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
              fill="#FFF"
            />
          </svg>
        </div>
        <div
          className={`sousMenuM ${openSubMenu === 'medias' ? 'sousMenuMOpen' : ''}`}
        >
          <LinkRouter
            to="/PhotosPage"
            className="sousMenuMItem"
            onClick={closeAll}
          >
            Photos
          </LinkRouter>
          <LinkRouter to="/Videos" className="sousMenuMItem" onClick={closeAll}>
            Vidéos
          </LinkRouter>
        </div>

        <LinkScroll
          to="Contacts"
          smooth
          duration={1000}
          className="menuMItem"
          onClick={closeAll}
        >
          Contacts
        </LinkScroll>
      </nav>
    </div>
  )
}

export default MenuMobile
